import { io } from "socket.io-client";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

let socket = null;

export const connectSocket = (token, onReceiveMessage, onUserTyping, onMessagesRead) => {
  if (socket && socket.connected) {
    return socket;
  }

  socket = io(`${API_URL}`, {
    auth: { token },
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    console.log("🟢 Connected to SoloWay Socket Server:", socket.id);
  });

  if (onReceiveMessage) {
    socket.on("receive_message", (message) => {
      onReceiveMessage(message);
    });
  }

  if (onUserTyping) {
    socket.on("user_typing", (data) => {
      onUserTyping(data);
    });
  }

  if (onMessagesRead) {
    socket.on("messages_read", (data) => {
      onMessagesRead(data);
    });
  }

  socket.on("disconnect", () => {
    console.log("🔴 Disconnected from SoloWay Socket Server");
  });

  return socket;
};

export const joinRoom = (conversationId) => {
  if (socket) {
    socket.emit("join_room", { conversationId });
  }
};

export const leaveRoom = (conversationId) => {
  if (socket) {
    socket.emit("leave_room", { conversationId });
  }
};

export const sendMessage = (conversationId, messageText) => {
  if (socket) {
    socket.emit("send_message", { conversationId, messageText });
  }
};

export const sendTypingStatus = (conversationId, isTyping) => {
  if (socket) {
    socket.emit("typing_status", { conversationId, isTyping });
  }
};

export const markMessagesRead = (conversationId) => {
  if (socket) {
    socket.emit("mark_read", { conversationId });
  }
};

export const sendSosAlert = (sosData) => {
  if (socket) {
    socket.emit("sos_alert", sosData);
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;
